import { jsx as _jsx } from "react/jsx-runtime";
//@ts-ignore
import ErrorPage, { PAGE_TYPES } from '@mindtickle/error-page';
//@ts-ignore
import Loader from '@mindtickle/loader';
export var DEFAULT_ERROR_FALLBACK = function () { return (_jsx(ErrorPage, { tryAgain: function () { var _a; return (_a = window.location) === null || _a === void 0 ? void 0 : _a.reload(); }, centered: true, pageType: PAGE_TYPES.CLIENT_ERROR, showGoToHome: false, showLogo: false }, void 0)); };
export var DEFAULT_DELAYED_FALLBACK = function () { return _jsx(Loader, { type: "Full" }, void 0); };
export var LOGGER_NAME = 'dynamic-remote';
export var PERFORMANCE_MEASURE_NAMES = {
    REMOTE_LOADED: 'remoteLoaded',
    MODULE_EVALUATION_COMPLETED: 'moduleEvaluationCompleted',
};
//# sourceMappingURL=constants.js.map